import React from "react";
import { Route, Routes } from "react-router-dom";
import WarehouseManagerDashboard from "../../pages/dashboard/WarehouseManagerDashboard";
import WarehouseStockRequisition from "../../pages/StoresRequisition/WarehouseStockRequisition";
import NewWarehouseStockRequisition from "../../pages/StoresRequisition/NewWarehouseStockRequisition";

const WarehouseManagerRoutes = () => {
  return (
    <Routes>
      <Route path="dashboard" element={<WarehouseManagerDashboard />} />
      <Route
        path="/inventory/requisition"
        element={<WarehouseStockRequisition />}
      />
      <Route
        path="/inventory/requisition/new"
        element={<NewWarehouseStockRequisition />}
      />
    </Routes>
  );
};

export default WarehouseManagerRoutes;
